<div class="mt-8 mb-4">
    @if (group$ | async; as group) {

    <div class="flex justify-between items-center w-full mb-4">

        <div class="flex flex-row justify-between">
            <app-btn-back [routeTo]="'/groups'"></app-btn-back>
        </div>


        <div class="flex justify-end items-end relative">
            <app-btn-fab (click)="toggleDropdown($event)" icon="fas fa-ellipsis-vertical"
                bgColor="bg-transparent hover:bg-gray-200 active:bg-gray-300"></app-btn-fab>
            <div class="min-w-48 z-50 absolute top-full right-0 mt-1 {{ dropdownPopoverShow ? 'block' : 'hidden'}}">
                <div
                    class="bg-white text-base p-1 list-none text-left rounded-lg shadow-lg min-w-48 border border-gray-100">
                    <a (click)="onViewProfile()" class="hover:bg-gray-200 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                                                            text-blueGray-700">
                        <i class="fa fa-user-astronaut mr-2 leading-relaxed"></i>
                        My Profile in Group
                    </a>
                    @if ((myRoles$ | async)?.admin || (myRoles$ | async)?.management) {
                    <a [routerLink]="['edit']" class="hover:bg-gray-200 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                                        text-blueGray-700">
                        <i class="fa fa-edit mr-2 leading-relaxed"></i>
                        Edit Details
                    </a>
                    }
                    @if (group?.groupType == groupType.school && (myRoles$ | async)?.management) {
                    <a [routerLink]="['newacademicyear']" class="hover:bg-gray-200 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700">
                        <i class="fa fa-add mr-2 leading-relaxed"></i>
                        New Academic Year
                    </a>
                    }
                </div>
            </div>
        </div>
    </div>

    <div class="bg-blueGray-100 mb-4">
        <div class="text-center flex justify-between items-center">
            <h6 class="text-primary-500 text-lg font-bold uppercase">
                {{group?.name}} ({{group?.academicYear}})
            </h6>
            <div class="flex flex-row gap-4 justify-center items-center">
                <span class="text-sm hidden lg:block text-blueGray-400">Membership:</span>
                <app-btn-member-status [status]="group?.memberStatus" [isDisabled]="true"></app-btn-member-status>
            </div>
        </div>
    </div>

    <div class="flex flex-col shadow-none bg-blueGray-100 border-0">

        <div class="flex flex-col-reverse lg:flex-row lg:gap-4">
            @if(group){
            <div class="w-full xl:w-8/12">
                <div class="relative w-full mb-3">

                    <div class="w-full lg:w-12/12 mb-8">
                        <div class="relative w-full mb-3">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                Description
                            </label>
                            <span class="text-blueGray-600 text-sm whitespace-pre-line">{{group.description}}</span>
                        </div>
                    </div>
                    <div class="w-full lg:w-12/12 mb-8">
                        <div class="flex flex-row justify-between items-start w-full">
                            <div class="flex flex-col">
                                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                    Address
                                </label>
                                <span class="text-blueGray-600 normal-case text-sm">{{group.address?.addressLine1 ??
                                    ''}}</span>
                                <span class="text-blueGray-600 normal-case text-sm">
                                    {{group.address?.addressLine2 ?? ''}}</span>
                                <span class="text-blueGray-600 normal-case text-sm"> {{group.address?.city}}</span>
                                <span class="text-blueGray-600 normal-case text-sm">
                                    {{group.address?.country}}</span>
                            </div>
                            @if (group?.location) {
                            <button (click)="openMap()" type="button"
                                class="text-primary-300 hover:text-primary-500 transition-colors ml-4 self-start focus:outline-none mr-8"
                                title="View Map">
                                <i class="fas fa-map-location-dot text-xl"></i>
                            </button>
                            }
                        </div>
                    </div>
                    @if (group.primaryContact?.contact) {
                    <div class="w-full lg:w-12/12 mb-8">
                        <div class="w-full">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                Primary Contact
                            </label>
                            <span
                                class="text-blueGray-600 capitalize text-sm">+{{group.primaryContact?.phoneCode}}</span>
                            <span class="text-blueGray-600 text-sm">
                                {{group.primaryContact?.contact}}</span>
                        </div>
                    </div>
                    }
                    @if (group.secondaryContact?.contact) {
                    <div class="w-full lg:w-12/12 mb-8">
                        <div class="w-full">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                Secondary Contact
                            </label>
                            <span
                                class="text-blueGray-600 capitalize text-sm">+{{group.secondaryContact?.phoneCode}}</span>
                            <span class="text-blueGray-600 text-sm">
                                {{group.secondaryContact?.contact}}</span>
                        </div>
                    </div>
                    }
                    <div class="w-full lg:w-12/12 mb-8">
                        <div class="w-full">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                Email
                            </label>
                            <span class="text-blueGray-600 text-sm">{{group.email}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full xl:w-4/12">
                @if (group?.imageUrl) {
                <div class="relative flex rounded-t justify-center items-center mb-6">
                    <img alt="..." [src]="group?.imageUrl"
                        class="shadow-xl rounded w-full object-cover mx-auto align-middle border-none max-h-[250px] lg:max-h-[400px]" />
                </div>
                } @else {
                <div
                    class="bg-primary-100 uppercase text-primary-500 text-4xl flex justify-center items-center text-center shadow-xl rounded w-full mb-6 min-h-[250px] lg:max-h-[400px]">
                    {{group.name | initials}}
                </div>
                }
            </div>
            }
        </div>

        <!-- Group Configurations Section -->
        @if (((myRoles$ | async)?.admin || (myRoles$ | async)?.management) && group.memberStatus ===
        membershipStatus.active) {
        <div class="w-full mb-8 pt-6 border-t border-blueGray-200">
            <h6 class="text-blueGray-600 text-sm font-bold uppercase mb-4">
                Group Configurations
            </h6>
            <div class="flex flex-col w-full gap-4">
                <div class="flex items-center gap-3 bg-white p-3 rounded-lg shadow-sm">
                    <div
                        class="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-500">
                        <i class="fas fa-robot text-lg"></i>
                    </div>
                    <div>
                        <span class="text-xs uppercase text-blueGray-400 font-bold block">AI Receipt Reader</span>
                        <span class="text-sm font-semibold text-blueGray-700">
                            {{ group?.isAiEnabled !== false ? 'Enabled' : 'Disabled' }}
                        </span>
                    </div>
                </div>

                <div class="flex items-center gap-3 bg-white p-3 rounded-lg shadow-sm">
                    <div
                        class="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-500">
                        <i class="fas fa-comments text-lg"></i>
                    </div>
                    <div>
                        <span class="text-xs uppercase text-blueGray-400 font-bold block">Group Chat</span>
                        <span class="text-sm font-semibold text-blueGray-700">
                            {{ group?.isChatAllowed !== false ? 'Allowed' : 'Not Allowed' }}
                        </span>
                    </div>
                </div>

                <div class="flex items-center gap-3 bg-white p-3 rounded-lg shadow-sm">
                    <div
                        class="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-500">
                        <i class="fas fa-coins text-lg"></i>
                    </div>
                    <div>
                        <span class="text-xs uppercase text-blueGray-400 font-bold block">Default Currency</span>
                        <span class="text-sm font-semibold uppercase text-blueGray-700">
                            {{ group?.currency || 'USD' }}
                        </span>
                    </div>
                </div>

                <div class="flex items-center gap-3 bg-white p-3 rounded-lg shadow-sm">
                    <div
                        class="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-500">
                        <i class="fas fa-book-bible text-lg"></i>
                    </div>
                    <div>
                        <span class="text-xs uppercase text-blueGray-400 font-bold block">Bible Type</span>
                        <span class="text-sm font-semibold capitalize text-blueGray-700">
                            {{ group?.bibleType || 'protestant' }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>
    }
</div>